import { createTheme } from "@mui/material/styles";

export const customTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#FF9800"
    },
    secondary: {
      main: "#424242"
    },
    background: {
      default: "#FFF8E1"
    }
  },
  typography: {
    fontFamily: "Roboto, sans-serif",
    fontSize: 17
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920
    }
  }
});
